import updateMenuDropdowns from "./components/updateNavDropdowns";
import {
  initFeedbackSlider,
  initBlogPostsSlider,
  initOffersWBgSlider,
  initOfferSlider,
  initOfferInnerSlider,
  initContentCardsSlider,
  initScreenOffersSlider,
} from "./components/sliders";
import initScrollDetector from "./components/scrollDetector";
import initSlideToggle from "./components/slideToggle";
import addOffersAccordion from "./components/offersAccordion";
import initTabs from "./components/tabs";
import {
  changeSliderFacetLabel,
  activeFacets,
  showSelectedFilters,
} from "./components/facetwp";
import triggerMoreText from "./components/btnToggleMore";
import NanoModal from "./components/modal";
import initOfferModal from "./components/offerModal";
import populateOfferFormInfo from "./components/offerForm";
import initDropdown from "./components/dropdown";
import { initOfferFromToCalendar } from "./components/flatpickr";
import copyUrlBtn from "./components/copyUrlBtn";
import modifyFooterBehaviour from "./components/footerPadding";
import initToggles from "./components/toggle";
import initContentAccordion from "./components/contentAccordion";
import initListViewToggle from "./components/toggleListView";
import initFilterToggle from "./components/filterToggle";
import addToFavourites from "./components/addToFavourites";
import updateFavouritesModal from "./components/updateFavsModal";
import hideEmptyModules from "./components/hideEmptyModules";
import positionOfferTablePriceLabels from "./components/offerTablePricePositions";
import fillNewsletterInput from "./components/fillNewsletterInput";
import openMobileTopNav from "./components/openMobileTopNav";
import scrollToCurrentMenuItem from "./components/makeActiveMenuItemVisible";
import { accTopMenu, accPrimaryMenu } from "./components/accessibility";
import initLoginStatus from "./components/userMenu";
import openPriceTableSingleLine from "./components/truggerPriceLineOpen";

window.jQuery();

jQuery(document).ready(function ($) {
  $(document).on("gform_confirmation_loaded", (event, formId) => {
    $("body").addClass("form-sent");

    var confirmationElem = $("#gform_confirmation_wrapper_" + formId);
    if (confirmationElem.length) {
      var confirmationTop = confirmationElem.offset().top;
      // Adjust the scroll position 200px above the confirmation message
      $("html, body").animate(
        {
          scrollTop: confirmationTop - 200, // Scroll 200px higher
        },
        200
      ); // Adjust scroll speed if needed
    }
  });
});

function initModalTriggers() {
  // Create an object to store modal instances
  const modals = {};

  // Add a single event listener to the document for event delegation
  document.addEventListener("click", (event) => {
    let targetElement = event.target;

    // Traverse up the DOM tree to check for the modal trigger, isConnected - classList does not exist for elements removed from DOM (#document-fragment) like Continue btn
    while (targetElement && targetElement.isConnected && targetElement !== document) {
      if (targetElement.classList.contains("open-modal")) {
        event.preventDefault(); // Prevent default action if needed
        const modalTarget = targetElement.dataset.modalTarget;
        const modalTrigger = targetElement; // Capture the trigger element

        // Initialize the modal if it hasn't been already
        if (!modals[modalTarget]) {
          modals[modalTarget] = new NanoModal(`#${modalTarget}`, {
            onShow: function () {
              const trigger = this.currentTrigger;
              if (trigger) {
                trigger.setAttribute("aria-expanded", "true");
                trigger.classList.add("modal-trigger-open");
              }
              if (sessionStorage.logged_in_user === undefined) return;
              try {
                let loggedInUser = JSON.parse(sessionStorage.logged_in_user);
              
                document.querySelector(`#${modalTarget} input[autocomplete=name]`).value = loggedInUser.firstname + " " + loggedInUser.lastname;
                document.querySelector(`#${modalTarget} input[autocomplete=email]`).value = loggedInUser.email;
                document.querySelector(`#${modalTarget} input[autocomplete=tel]`).value = loggedInUser.phone;
              } catch (e) {

              }
            },
            onClose: function () {
              // console.log("Modal closed");
              const trigger = this.currentTrigger;
              if (trigger) {
                trigger.setAttribute("aria-expanded", "false");
                trigger.classList.remove("modal-trigger-open");
              }
            },
            closeOnEscape: true,
            closeOnOutsideClick: false,
            disableScrollShift: false,
            disableScroll: true,
            debug: true,
          });
        }

        // Set the current trigger so it's accessible in onShow and onClose
        modals[modalTarget].currentTrigger = modalTrigger;

        // Show the modal
        modals[modalTarget].showModal();

        break; // Stop traversing once the trigger is found
      }
      targetElement = targetElement.parentNode;
    }
  });
}

function openChat() {
  const buttons = document.querySelectorAll(
    ".wp-block-button__link.wp-element-button"
  );

  buttons.forEach(function (button) {
    if (button.getAttribute("href") === "#chat") {
      buttons.forEach(function (button) {
        button.setAttribute(
          "onclick",
          "LiveChatWidget.call('maximize'); return false;"
        );
      });
    }
  });
}

function onChatReady() {
  let prefill = () => {
    if (sessionStorage.logged_in_user === undefined) return;
    let loggedInUser = JSON.parse(sessionStorage.logged_in_user);
    
    window.LiveChatWidget.call("set_customer_name", loggedInUser.firstname + " " + loggedInUser.lastname);
    window.LiveChatWidget.call("set_customer_email", loggedInUser.email);
  }
  try {
    window.LiveChatWidget.on('ready', prefill);
    setTimeout(prefill, 6000);
  } catch {
    // Make sure rest of the JS does not stop execution
    console.warn("LiveChatWidget does not exist.");
  }
}

initScrollDetector();
initSlideToggle();

copyUrlBtn();

addOffersAccordion();
modifyFooterBehaviour();

initTabs();

changeSliderFacetLabel();
activeFacets();
showSelectedFilters();

triggerMoreText();

function runOnLoadAndDocumentReady() {
  initLoginStatus();
  openPriceTableSingleLine();

  openChat();
  onChatReady()

  accTopMenu();
  accPrimaryMenu();

  scrollToCurrentMenuItem();
  openMobileTopNav();
  addToFavourites();
  updateFavouritesModal();

  initModalTriggers();

  populateOfferFormInfo();
  initDropdown();
  initOfferFromToCalendar();

  setTimeout(() => {
    updateMenuDropdowns();
  }, 10);

  initFeedbackSlider();
  initBlogPostsSlider();
  initOffersWBgSlider();
  initContentCardsSlider();
  initOfferSlider();
  initOfferInnerSlider();
  initScreenOffersSlider();
  initListViewToggle();
  initFilterToggle();
  // hideEmptyModules();
  fillNewsletterInput();

  setTimeout(() => {
    positionOfferTablePriceLabels();
  }, 0);

  document
    .querySelectorAll(".offers-accordion-item__header .btn-primary")
    .forEach((button) => {
      button.addEventListener("click", function (event) {
        console.log("Button clicked");
      });
    });

  initOfferModal();

  initToggles();

  const backButton = document.querySelector(".back-button");
  if (backButton) {
    backButton.addEventListener("click", function () {
      var referrer = document.referrer;
      var homeUrl = backButton.getAttribute("data-home-url");
      if (referrer.indexOf(window.location.hostname) !== -1) {
        window.history.back();
      } else {
        window.location.href = homeUrl;
      }
    });
  }

  initContentAccordion();

  const buttons = document.querySelectorAll(".offer-button");

  buttons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default action of the button
      event.stopPropagation(); // Stop the click event from propagating
    });
  });

  const urlHash = window.location.hash;

  if (urlHash === "#reisikonsultant") {
    const travelConsultantModal = new NanoModal("#travel-consultant", {
      closeOnOutsideClick: true,
      debug: false,
    });
    travelConsultantModal.showModal(); // Automatically open the modal
  }

  if (urlHash === "#newsletter") {
    const newsletterModal = new NanoModal("#newsletter", {
      closeOnOutsideClick: true,
      debug: false,
    });
    newsletterModal.showModal(); // Automatically open the modal
  }
}

if (document.readyState !== "loading") {
  runOnLoadAndDocumentReady();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    runOnLoadAndDocumentReady();
  });
}
